<button class="c-botao text-truncate" [matTooltip]="nomesEquipamentos" [disabled]="!nomesEquipamentos"
  (click)="abrirModal()">{{nomesEquipamentos || "Sem dados"}}</button>

<app-modal-general [showOrHideButton]="false" [showOrHideMessage]="false" #modal>
  <table class="c-table-container__table" mat-table [dataSource]="equipamentosSuprimento.registros">
    <ng-container matColumnDef="codProduto">
      <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
        <div class="u-border-none c-table-container__table__header-text">Código</div>
      </th>
      <td class="c-table-container__table__cell" mat-cell *matCellDef="let equipamentoSuprimento">
        {{equipamentoSuprimento.codProduto
        || "Sem dados"}}</td>
    </ng-container>
    <ng-container matColumnDef="nomeProduto">
      <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
        <div class="u-border-none c-table-container__table__header-text">Descrição</div>
      </th>
      <td class="c-table-container__table__cell" mat-cell *matCellDef="let equipamentoSuprimento">
        {{equipamentoSuprimento.nomeProduto
        || "Sem dados"}}</td>
    </ng-container>
    <tr class="c-table-container__table__header-row" mat-header-row *matHeaderRowDef="colunasVisiveis; sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
  </table>
</app-modal-general>